<div
  class="d-flex flex-wrap align-items-center justify-content-between me-3 gap-3 bg-body-tertiary p-3 rounded-4 border shadow-sm">
  <!-- Left Control Group: Navigation Anchors -->
  <div>
    <button type="button"
      class="btn btn-sm btn-outline-secondary d-inline-flex align-items-center gap-1.5 px-3 py-2 shadow-sm text-body fw-semibold transition-base"
      (click)="goBack()">
      <i class="bi bi-arrow-left"></i>
      <span>Back</span>
    </button>
  </div>

  <!-- Right Control Group: Dynamic Multi-Access Operations Command Array -->
  <div class="d-flex flex-wrap align-items-center gap-2 ms-auto">
    <!-- NRC Operational Workflow Verification Toggle Button -->
    @if (
    isNRCVerifyAccess() &&
    customerdata()?.nrcVerifiedBy &&
    customerdata()?.nrcFrontImage !== null &&
    customerdata()?.nrcBackImage !== null
    ) {
    <div>
      <button type="button"
        class="btn btn-sm btn-outline-danger px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base"
        (click)="UnverifyNrc()">
        <i class="bi bi-shield-x"></i>
        <span>Unverify NRC</span>
      </button>
    </div>
    }

    <!-- Audit Rejection Reason Dialog Trigger Button -->
    @if (haveAccess() && !showReasonbtn()) {
    <div>
      <button type="button"
        class="btn btn-sm btn-outline-info px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold text-body transition-base"
        (click)="getUnVerifyReasonInfo()" data-bs-toggle="modal" data-bs-target="#showUnVerifyReason">
        <i class="bi bi-chat-square-text text-body"></i>
        <span>Unverify Reason</span>
      </button>
    </div>
    }

    <!-- Consolidated Operational Command Dropdown Menu Drawer Section -->
    <div class="dropdown">
      <button type="button"
        class="btn btn-sm btn-primary px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold dropdown-toggle no-caret"
        data-bs-toggle="dropdown" aria-expanded="false">
        <i class="fa-solid fa-user-gear font-xs"></i>
        <span>Manage Account</span>
      </button>
      <ul class="dropdown-menu dropdown-menu-end shadow border-0 mt-2 font-xs">
        <li>
          <button class="dropdown-item py-2 d-inline-flex align-items-center gap-2" type="button"
            (click)="updateCustomerInfo()" data-bs-toggle="modal" data-bs-target="#updateInfoModel">
            <i class="bi bi-person-vcard text-body-secondary"></i>Update Info
          </button>
        </li>
        <li>
          <button class="dropdown-item py-2 d-inline-flex align-items-center gap-2" type="button"
            (click)="UpdateRedeemLimit()">
            <i class="bi bi-sliders text-body-secondary"></i>Update Redeem Limit
          </button>
        </li>
        <li>
          <hr class="dropdown-divider opacity-10" />
        </li>
        <li>
          <button class="dropdown-item py-2 d-inline-flex align-items-center gap-2" type="button"
            (click)="goToQRClaimPage()">
            <i class="bi bi-qr-code text-body-secondary"></i>QrCode Claim
          </button>
        </li>
        <li>
          <button class="dropdown-item py-2 d-inline-flex align-items-center gap-2" type="button"
            (click)="goToExChangePage()">
            <i class="bi bi-list-check text-body-secondary"></i>Exchange List
          </button>
        </li>
        <li>
          <button class="dropdown-item py-2 d-inline-flex align-items-center gap-2" type="button"
            (click)="goToLMSRedeemListPage()">
            <i class="bi bi-mortarboard text-body-secondary"></i>LMS Redeem List
          </button>
        </li>
      </ul>
    </div>

    <!-- Rapid Account Access Governance State Toggles -->
    <div>
      @if (!customerdata()?.enabled) {
      <button type="button"
        class="btn btn-sm btn-success px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base"
        (click)="CustomerLoginEnableDisable('enabled')">
        <i class="bi bi-check-circle"></i>
        <span>Enable Account</span>
      </button>
      }
      @if (customerdata()?.enabled) {
      <button type="button"
        class="btn btn-sm btn-danger px-3 py-2 shadow-sm d-inline-flex align-items-center gap-1.5 fw-semibold transition-base"
        (click)="CustomerLoginEnableDisable('disabled')">
        <i class="bi bi-ban"></i>
        <span>Disable Account</span>
      </button>
      }
    </div>
  </div>
</div>

<div class="card border shadow-sm rounded-4 bg-body mt-3 mb-4 overflow-hidden w-100">
  <div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 table-dense text-nowrap">
      <!-- Table Header -->
      <thead class="table-light text-body-secondary font-monospace font-xs text-uppercase border-bottom">
        <tr>
          <th scope="col" class="ps-3 py-2.5">Current points</th>
          <th scope="col" class="py-2.5">Total points</th>
          <th scope="col" class="py-2.5">Daily redeem limit</th>
          <th scope="col" class="text-center py-2.5" width="100">Enabled</th>
          <th scope="col" class="text-center py-2.5" width="140">Illegal claims</th>
          <th scope="col" class="text-center py-2.5" width="120">Has messages</th>
          <th scope="col" class="text-center py-2.5" width="150">New messages</th>
        </tr>
      </thead>

      <!-- Table Body Row -->
      <tbody class="font-xs text-body">
        <tr class="transition-base">
          <!-- Numerical Metrics -->
          <td class="ps-3 fw-bold text-success-emphasis font-monospace fs-6">
            {{ customerdata()?.currentPoints | number }}
          </td>
          <td class="text-body-secondary font-monospace fs-6">{{ customerdata()?.totalPoints | number }}</td>
          <td class="text-body-secondary font-monospace fs-6">{{ customerdata()?.dailyRedeemableLimit | number }}</td>

          <!-- System State Toggles -->
          <td class="text-center">
            <i class="bi fs-5" [ngClass]="
                customerdata()?.enabled ? 'bi-check-circle-fill text-success' : 'bi-x-circle-fill text-danger'
              "></i>
          </td>

          <td class="text-center">
            <i class="bi fs-5" [ngClass]="
                customerdata()?.hasIllegalClaims
                  ? 'bi-exclamation-triangle-fill text-danger'
                  : 'bi-check-circle-fill text-success-emphasis'
              "></i>
          </td>

          <!-- <td class="text-center">
            <i class="bi fs-5"
              [ngClass]="customerdata()?.hasMessages ? 'bi-envelope-fill text-primary' : 'bi-envelope text-body-secondary opacity-50'"></i>
          </td>

          <td class="text-center">
            <i class="bi fs-5"
              [ngClass]="customerdata()?.hasNewMessages ? 'bi-envelope-open-fill text-warning' : 'bi-envelope text-body-secondary opacity-50'"></i>
          </td> -->
        </tr>
      </tbody>
    </table>
  </div>
</div>

<!-- ========================================== -->
<!-- CORE CUSTOMER PROFILE METADATA LEDGER      -->
<!-- ========================================== -->
<div class="card border shadow-sm rounded-4 bg-body overflow-hidden w-100">
  <div class="table-responsive m-0">
    <table class="table table-hover align-middle mb-0 table-dense" style="table-layout: fixed; width: 100%">
      <!-- 1. ADD THIS COLGROUP TO FORCE THE 25/75 SPLIT -->
      <colgroup>
        <col style="width: 40%">
        <col style="width: 60%">
      </colgroup>

      <!-- Table Header Matrix Layout -->
      <thead class="table-light text-body-secondary border-bottom font-monospace font-xs text-uppercase tracking-wider">
        <tr>
          <th scope="col" colspan="2" class="ps-3 py-2.5 fw-bold">Customer Info</th>
        </tr>
      </thead>

      <!-- Table Body Data Entries Layout -->
      <tbody class="font-xs text-body">
        <!-- Name Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">
            Name
          </td>
          <td class="fw-bold text-body" style="width: 75%">
            {{ customerdata()?.name | titlecase }}
          </td>
        </tr>

        <!-- Phone Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Login Phone</td>
          <td class="font-monospace fw-semibold text-body">{{ customerdata()?.loginPhone }}</td>
        </tr>

        <!-- Wallet Accounts Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Wallet Accounts</td>
          <td>
            <div class="d-inline-flex gap-1.5 flex-wrap">
              <!-- KBZ Account Popover Trigger -->
              <ng-template #kbzPopContent>
                <div class="font-xs text-body p-1">
                  <div><strong>Name:</strong> {{ kbzPayAccount?.paymentName || '-' }}</div>
                  <div class="font-monospace mt-0.5">
                    <strong>Phone:</strong> {{ kbzPayAccount?.paymentPhone || '-' }}
                  </div>
                </div>
              </ng-template>
              <button type="button" class="btn btn-sm btn-light border font-xs fw-semibold py-1 px-2"
                [ngbPopover]="kbzPopContent" popoverTitle="KBZ Account" triggers="hover focus" placement="top">
                <i class="bi bi-wallet2 me-1 text-primary"></i>KBZ Pay
              </button>

              <!-- AYA Account Popover Trigger -->
              <ng-template #ayaPopContent>
                <div class="font-xs text-body p-1">
                  <div><strong>Name:</strong> {{ ayaPayAccount?.paymentName || '-' }}</div>
                  <div class="font-monospace mt-0.5">
                    <strong>Phone:</strong> {{ ayaPayAccount?.paymentPhone || '-' }}
                  </div>
                </div>
              </ng-template>
              <button type="button" class="btn btn-sm btn-light border font-xs fw-semibold py-1 px-2 ms-1"
                [ngbPopover]="ayaPopContent" popoverTitle="AYA Account" triggers="hover focus" placement="top">
                <i class="bi bi-wallet2 me-1 text-info"></i>AYA Pay
              </button>

              <!-- Wave Account Popover Trigger -->
              <ng-template #wavePopContent>
                <div class="font-xs text-body p-1">
                  <div><strong>Name:</strong> {{ wavePayAccount?.paymentName || '-' }}</div>
                  <div class="font-monospace mt-0.5">
                    <strong>Phone:</strong> {{ wavePayAccount?.paymentPhone || '-' }}
                  </div>
                </div>
              </ng-template>
              <button type="button" class="btn btn-sm btn-light border font-xs fw-semibold py-1 px-2 ms-1"
                [ngbPopover]="wavePopContent" popoverTitle="Wave Account" triggers="hover focus" placement="top">
                <i class="bi bi-wallet2 me-1 text-warning"></i>Wave Pay
              </button>
            </div>
          </td>
        </tr>

        <!-- Topup Phones Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Topup Phones</td>
          <td class="font-monospace text-body-secondary">{{ topupPhones || '-' }}</td>
        </tr>

        <!-- Profile Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Profile</td>
          <td class="text-body-secondary">{{ customerdata()?.profile || '-' }}</td>
        </tr>

        <!-- Email Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Email</td>
          <td class="text-lowercase text-body-secondary">{{ customerdata()?.email || '-' }}</td>
        </tr>

        <!-- Occupation Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Occupation</td>
          <td class="text-body-secondary">{{ customerdata()?.occupation || '-' }}</td>
        </tr>

        <!-- NRC Operations Matrix Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">NRC</td>
          <td>
            <div class="d-inline-flex align-items-center gap-1.5 flex-wrap">
              <span class="font-monospace fw-bold text-body me-2">{{ customerdata()?.nrc || '—' }}</span>

              @if (customerdata()?.nrcFrontImage !== null) {
              <button type="button"
                class="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 font-xs py-0.5 px-2"
                (click)="showNrc('front')">
                <i class="fa-solid fa-eye"></i> Front
              </button>
              <button type="button"
                class="btn btn-sm btn-outline-primary d-inline-flex align-items-center gap-1 font-xs py-0.5 px-2"
                (click)="showNrc('back')">
                <i class="fa-solid fa-eye"></i> Back
              </button>
              }

              @if (
              customerdata()?.nrcFrontImage !== null &&
              !customerdata()?.nrcVerifiedBy &&
              customerdata()?.nrcBackImage !== null
              ) {
              <button type="button"
                class="btn btn-sm btn-success d-inline-flex align-items-center gap-1 font-xs py-0.5 px-2 shadow-sm"
                data-bs-toggle="modal" data-bs-target="#verifyNrcConfirm">
                <i class="fa-solid fa-triangle-exclamation font-xs"></i> Verify
              </button>
              }

              @if (customerdata()?.nrcVerifiedBy) {
              <span
                class="badge bg-success-subtle text-success-emphasis border border-success-subtle rounded-pill px-2.5 py-1.5 d-inline-flex align-items-center gap-1 font-xs">
                <i class="fa-solid fa-circle-check"></i> Already Verified
              </span>
              }
            </div>
          </td>
        </tr>

        <!-- NRC Verified By Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">NRC Verify By</td>
          <td class="font-monospace text-body-secondary">{{ customerdata()?.nrcVerifiedBy || '-' }}</td>
        </tr>

        <!-- Info Verification Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Info Verify By</td>
          <td>
            @if (valueInfoVerified()) {
            <div class="d-inline-flex align-items-center gap-2">
              <span class="text-body fw-medium"><i class="bi bi-person-badge text-body-secondary me-1.5"></i>Verified By
                {{ customerdata()?.upgVerifiedBy }}</span>
              <button type="button" class="btn btn-sm btn-outline-danger py-0.5 px-2 font-xs transition-base"
                (click)="verifiedInfoBy()">
                <i class="bi bi-shield-x"></i> Unverified
              </button>
            </div>
            } @else {
            <button type="button"
              class="btn btn-sm btn-outline-success py-0.5 px-2 font-xs d-inline-flex align-items-center gap-1"
              data-bs-toggle="modal" data-bs-target="#showInfoVerifyDialog">
              <i class="bi bi-shield-check"></i> Verify
            </button>
            }
          </td>
        </tr>

        <!-- Customer Type Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Customer Type</td>
          <td>
            <span
              class="badge bg-body-secondary text-body-secondary border border-secondary-subtle px-2.5 py-1 shadow-sm font-xs fw-medium">
              {{ customerdata()?.customerType || '-' }}
            </span>
          </td>
        </tr>

        <!-- Company Register No. Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">
            Company Register No.
          </td>
          <td class="font-monospace text-body-secondary">{{ customerdata()?.companyRegisterNo || '-' }}</td>
        </tr>

        <!-- Address Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Address</td>
          <td class="text-body-secondary">
            {{ customerdata()?.address1 }} {{ customerdata()?.address2 }} {{ customerdata()?.address3 }}
          </td>
        </tr>

        <!-- City Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">City / Township</td>
          <td class="text-body-secondary">{{ customerdata()?.city || '-' }} / {{ customerdata()?.township || '-' }}</td>
        </tr>

        <!-- State Row -->
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">
            Division / State
          </td>
          <td class="text-body-secondary">{{ customerdata()?.divisionState || '-' }}</td>
        </tr>
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Unverified Note</td>
          <td class="text-body-secondary">{{ customerdata()?.unverifiedReasonNote || '-' }}</td>
        </tr>
        <tr class="transition-base">
          <td class="ps-3 text-body-secondary fw-bold font-monospace text-uppercase tracking-wider">Info Remark</td>
          <td class="text-body-secondary">{{ customerdata()?.infoRemark || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>

<div class="row g-4 align-items-start justify-content-center my-4">
  <!-- Left empty spacer removed or kept small to balance the layout naturally -->
  <div class="col-md-2 d-none d-md-block"></div>

  <!-- Center Image Viewer Column -->
  <div class="col-md-5 d-flex flex-column align-items-center">
    @if (imgSrc) {
    <div class="image-viewer-wrapper shadow-sm rounded-3 overflow-hidden bg-light">
      <angular-image-viewer class="imageView" [src]="[imgSrc]" [(index)]="imageIndex" [config]="config"
        [footerTexts]="[]" [imageName]="imageName">
      </angular-image-viewer>
    </div>
    }
  </div>

  <!-- Right Profile Column -->
  <div class="col-md-3 d-flex flex-column align-items-center">
    @if (userProfile()) {
    <h5 class="imageheader text-secondary font-monospace text-uppercase tracking-wider mb-3 small fw-bold text-center">
      Customer Profile
    </h5>
    <div class="profile-image-wrapper shadow-sm rounded-circle overflow-hidden border bg-white">
      <img [src]="userProfile()" alt="User Profile" class="imageViewProfile img-fluid" />
    </div>
    }
  </div>

  <div class="col-md-2 d-none d-md-block"></div>
</div>

<!-- ========================================== -->
<!-- NRC VERIFICATION DIALOG MODAL CONTROLLER   -->
<!-- ========================================== -->
<div class="modal fade" id="verifyNrcConfirm" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-sm">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom-0 pb-0 pt-4 px-4">
        <h5 class="modal-title fw-bold text-gradient-primary d-flex align-items-center">
          <i class="bi bi-shield-check me-2 fs-4"></i>NRC Verify
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body py-3 px-4 text-body-secondary font-xs fw-semibold">
        Are you sure you want to Verify this profile documentation?
      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top-0 pt-2 pb-4 px-4 gap-2">
        <button type="button" class="btn btn-sm btn-light px-3 fw-medium text-body-secondary"
          data-bs-dismiss="modal">Cancel</button>
        <!-- Data-bs-dismiss added to native yes trigger to cleanly dismiss the backdrop overlay framework on execution -->
        <button type="button"
          class="btn btn-sm btn-success px-4 fw-bold shadow-sm d-inline-flex align-items-center gap-1.5 micro-action-btn"
          data-bs-dismiss="modal" (click)="verifyNrc()">
          <span>Yes</span>
        </button>
      </div>

    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- AUDIT AUDITING REJECTION CAUSE FORM MODAL   -->
<!-- ========================================== -->
<div class="modal fade" id="showUnVerifyReason" tabindex="-1" aria-hidden="true" cdkDrag>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3 cursor-pointer" cdkDragHandle>
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="fa-solid fa-triangle-exclamation me-2"></i>Create Unverify Reason
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4 d-flex flex-column gap-3">

        <!-- Multi-Choice Audit Checklist Node Fields Layout -->
        <div class="d-flex flex-column gap-2 bg-body-tertiary p-3 rounded-3 border">
          <label class="form-label font-xs fw-bold text-body-secondary text-uppercase tracking-wider mb-1">Rejection
            Check Items</label>
          @for (checkbox of checkboxes; track checkbox.label) {
          <div class="form-check d-flex align-items-center gap-2 m-0 min-h-auto py-1">
            <input class="form-check-input mt-0 cursor-pointer" type="checkbox" id="check-{{$index}}"
              [(ngModel)]="checkbox.value" />
            <label class="form-check-label font-xs text-body cursor-pointer fw-medium" for="check-{{$index}}">
              {{ checkbox.label }}
            </label>
          </div>
          }
        </div>

        <!-- Text Area Input Block -->
        <div>
          <label class="form-label font-xs fw-bold text-body-secondary text-uppercase tracking-wider mb-1.5">Unverified
            Note</label>
          <textarea class="form-control text-body font-xs shadow-sm" rows="3" [(ngModel)]="unverifiedNote"
            placeholder="Enter explicit reason detail summary..."></textarea>
        </div>


        <div>
          <label class="form-label font-xs fw-bold text-body-secondary text-uppercase tracking-wider mb-1.5">Unverified
            By</label>
          <div class="input-group shadow-sm rounded">
            <span class="input-group-text border bg-body text-body-secondary font-xs"><i
                class="bi bi-person-badge"></i></span>
            <input type="text" class="form-control text-body font-xs border-start-0 ps-0" [(ngModel)]="unverifiedBy"
              placeholder="Enter auditing admin name..." />
          </div>
        </div>

      </div>

      <!-- Modal Footer -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2 micro-action-btn"
          (click)="submitUnverifyReason()" [disabled]="!unverifiedBy.trim()">
          <span>Submit <i class="fa-solid fa-paper-plane font-xs"></i></span>
        </button>
      </div>

    </div>
  </div>
</div>


<!-- Update Info Modal -->
<div class="modal" id="updateInfoModel" tabindex="-1" aria-hidden="true" cdkDrag>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Customer Info</h5>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <form [formGroup]="updateCustomerInfoForm">
            <div class="row mb-2">
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingName" placeholder="Name" formControlName="name" />
                <label for="floatingName">Name</label>
              </div>
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingProfile" placeholder="Profile"
                  formControlName="profile" />
                <label for="floatingProfile">Profile</label>
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingEmail" placeholder="Email"
                  formControlName="email" />
                <label for="floatingEmail">Email</label>
              </div>
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingCompanyRegisterNo" placeholder="CompanyRegisterNo"
                  formControlName="companyRegisterNo" />
                <label for="floatingCompanyRegisterNo">Company Register No</label>
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-floating col">
                <select class="form-control form-select" id="floatingOccupation" formControlName="occupation">
                  <option value="" disabled selected>Select Occupation</option>
                  @for (occupation of userOccupations; track occupation) {
                  <option [value]="occupation">
                    {{ occupation }}
                  </option>
                  }
                </select>
                <label for="floatingOccupation">Occupation</label>
              </div>

              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingViberPhone" placeholder="Viber Phone"
                  formControlName="viberPhone" />
                <label for="floatingViberPhone">Viber Phone</label>
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-floating col">
                <select class="form-control form-select" id="floatingdivisionState" formControlName="divisionState"
                  (change)="onStateChange($event)">
                  <option value="" disabled selected>Select State</option>
                  @if (!isENG) {
                  @for (state of stateList; track state) {
                  <option [value]="state">
                    {{ state }}
                  </option>
                  }
                  } @else {
                  @for (state of stateENGList; track state) {
                  <option [value]="state">
                    {{ state }}
                  </option>
                  }
                  }
                </select>
                <label for="floatingdivisionState">Division State</label>
              </div>
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingTownship" placeholder="Township"
                  formControlName="township" [ngbTypeahead]="searchList" />
                <label for="floatingTownship">Township</label>
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingCity" placeholder="City" formControlName="city" />
                <label for="floatingCity">City</label>
              </div>
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingAddress1" placeholder="Address1"
                  formControlName="address1" />
                <label for="floatingAddress1">Address 1</label>
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingAddress2" placeholder="Address2"
                  formControlName="address2" />
                <label for="floatingAddress2">Address 2</label>
              </div>
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingAddress3" placeholder="Address3"
                  formControlName="address3" />
                <label for="floatingAddress3">Address 3</label>
              </div>
            </div>

            <div class="row mb-2">
              <div class="form-floating col">
                <input type="text" class="form-control" id="floatingNRC" placeholder="NRC" formControlName="nrc"
                  readonly />
                <label for="floatingNRC">NRC</label>
              </div>
            </div>
            <div class="d-flex bd-highlight">
              <div class="bd-highlight">
                <select class="form-control form-select" (change)="onNrcStateCodeChange($event)">
                  <option value="" disabled selected>Select State Code</option>
                  @for (code of nrcCodeList; track code) {
                  <option [value]="code">
                    {{ code }}
                  </option>
                  }
                </select>
              </div>
              <div class="ms-1 bd-highlight">
                <select class="form-control form-select" (change)="onNrcTownShipChange($event)">
                  <option value="" disabled selected>Select Township Name</option>
                  @for (city of nrcCityNameList; track city) {
                  <option [value]="city">
                    {{ city }}
                  </option>
                  }
                </select>
              </div>
              <div class="ms-1 bd-highlight">
                <select class="form-control form-select" (change)="onNrcCitizenChange($event)">
                  <option value="" disabled selected>Select Citizen Status</option>
                  @for (status of nrcStatusList; track status) {
                  <option [value]="status">
                    {{ status }}
                  </option>
                  }
                </select>
              </div>
              <div class="ms-1 flex-grow-1 bd-highlight" (input)="onNrcNoChange($event)">
                <input type="number" class="form-control" id="" placeholder="NRC No" />
              </div>
            </div>
          </form>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary" (click)="updateCustomerInfoBy()"
          [disabled]="!updateCustomerInfoForm.valid">
          @if (isUploading()) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          } @else {
          <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ========================================== -->
<!-- INFO VERIFICATION DIALOG MODAL CONTROLLER  -->
<!-- ========================================== -->

<div class="modal fade" id="showInfoVerifyDialog" tabindex="-1" aria-hidden="true" cdkDrag>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content shadow-lg border-0 bg-body">

      <!-- Modal Header -->
      <div class="modal-header border-bottom px-4 py-3 cursor-pointer" cdkDragHandle>
        <h5 class="modal-title fw-bold text-gradient-primary">
          <i class="bi bi-shield-check me-2"></i>Info Verify
        </h5>
        <button type="button" class="btn-close shadow-none" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>

      <!-- Modal Body -->
      <div class="modal-body px-4 py-4 d-flex flex-column gap-3">

        <!-- Customer Type Selection Block -->
        <div>
          <label for="customer_type"
            class="form-label font-xs fw-bold text-body-secondary text-uppercase tracking-wider mb-1.5">Customer
            Type</label>
          <div class="input-group shadow-sm rounded">
            <span class="input-group-text border bg-body text-body-secondary font-xs"><i
                class="bi bi-person-gear"></i></span>
            <select class="form-select text-body font-xs border-start-0 ps-0" id="customer_type" name="customer_type"
              [(ngModel)]="custeomerType">
              <option value="CUSTOMER">CUSTOMER</option>
              <option value="DEALER">DEALER</option>
              <option value="PAINTING_SERVICE">PAINTING_SERVICE</option>
            </select>
          </div>
        </div>

        <!-- Info Remark Text Area Block -->
        <div>
          <label class="form-label font-xs fw-bold text-body-secondary text-uppercase tracking-wider mb-1.5">Info
            Remark</label>
          <textarea class="form-control text-body font-xs shadow-sm" rows="3" [(ngModel)]="infoRemark" maxlength="128"
            placeholder="Enter administrative validation notes..."></textarea>
          <div class="form-text text-end font-monospace font-xs mt-1 text-body-secondary">
            {{ infoRemark.length || 0 }}/128 chars
          </div>
        </div>

      </div>

      <!-- Modal Footer Controls -->
      <div class="modal-footer border-top px-4 py-2.5">
        <button type="button" class="btn btn-sm btn-secondary opacity-75 shadow-sm px-3 py-1.5 fw-medium"
          data-bs-dismiss="modal">Close</button>
        <button type="button"
          class="btn btn-sm btn-primary px-4 py-1.5 shadow-sm fw-bold d-inline-flex align-items-center gap-2 micro-action-btn"
          (click)="verifiedInfoBy()" [disabled]="!custeomerType">
          <span>Submit <i class="fa-solid fa-paper-plane font-xs"></i></span>
        </button>
      </div>

    </div>
  </div>
</div>